export default "__VITE_ASSET__BQTjxLu0__"